module.exports = __webpack_public_path__ + "img/mamizou futatsuiwa.e984c530.png";